import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function GetAllUserCentre(id:number):Promise<UserCentre[]>{
    const res:any = await dataFetcher(`user_centres?User=${id}`, {method:'get'})
    return res["hydra:member"]
}